

























































































































































































































































import Vue from 'vue'
import Modal from './Modal.vue'
import MobileModal from './MobileModal.vue'

const ShareCopies = {
  emailSubject: 'Comprueba que tan confiable eres para procesos de contratación con Truchecks',
  emailBody: 'Yo soy un candidato confiable ¿y tú?. Si quieres comprobar que tu también lo eres sólo debes descargar tu reporte en el siguiente link (https://bit.ly/2U97cQ7). ¡No olvides descargar la imagen y compartir tus resultados!'
}

export default Vue.extend({
  name: 'ShareModal',
  components: {
    Modal,
    MobileModal
  },
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    score: {
      type: Number,
      default: 1
    },
    image: {
      type: String,
      default: ''
    }
  },
  data: () => {
    return {
      dialogStatus: false,
      Modal,
      MobileModal,
      fullNameInputField: '',
      emailInputField: ''
    }
  },
  model: {
    prop: 'dialog',
    event: 'changeState'
  },
  watch: {
    dialogStatus () {
      this.$emit('changeState', this.dialogStatus)
    },
    dialog () {
      this.dialogStatus = this.dialog
    }
  },
  computed: {
    socialMediaCopy: {
      get () {
        const normalizedScore = Math.floor(10 * this.score)
        return `Acabo de validar mis antecedentes con Truchecks y soy un candidato ${normalizedScore} ¿y tú?\n\nVerifica tus antecedentes en minutos y aplica al trabajo de tus sueños, aquí`
      }
    },
    emailShareLink: {
      get () {
        if (!this.emailInputField || this.emailInputField === '') {
          return ''
        }

        const recipientName = this.fullNameInputField as String
        const body = `Hola ${recipientName}, \n\n${ShareCopies.emailBody}`

        const address = this.emailInputField as String
        if (address.endsWith('gmail.com')) {
          const url = `https://mail.google.com/mail/u/0/?fs=1&ui=2&tf=cm&to=${address}&su=${ShareCopies.emailSubject}&body=${body}`

          const encodedURL: string = encodeURI(url)
          return encodedURL
        }

        const defaultURL = `mailto:${address}?body=${body}&subject=${ShareCopies.emailSubject}`

        const encodedURL: string = encodeURI(defaultURL)
        return encodedURL
      }
    }
  },
  methods: {
    emitChangeVersion () {
      this.$emit('change-version')
    },
    getTwitterURL (): string {
      const baseURL = 'https://twitter.com/intent/tweet'
      const url = `url=${'https://bit.ly/2U97cQ7'}`
      const postMessage = `text=${this.socialMediaCopy}`

      return encodeURI(`${baseURL}?${url}&${postMessage}`)
    },
    getFacebookURL (): string {
      const baseURL = 'https://www.facebook.com/sharer/sharer.php'
      const text = `quote=${this.socialMediaCopy}`
      const url = `u=${'https://bit.ly/2U97cQ7'}`
      return encodeURI(`${baseURL}?${url}&${text}`)
    },
    getLinkedinURL (): string {
      const baseURL = 'https://www.linkedin.com/sharing/share-offsite/'
      const url = `url=${'https://bit.ly/2U97cQ7'}`
      return encodeURI(`${baseURL}?${url}`)
    },
    getWhatsAppURL (): string {
      const baseURL = 'https://wa.me/'
      const text = `text=${this.socialMediaCopy} ${'https://bit.ly/2U97cQ7'}`
      return encodeURI(`${baseURL}?${text}`)
    }
  },
  mounted () {
    this.dialogStatus = this.dialog
  }
})
